import _ from 'lodash'

export function cleanPrinters (menuBlob, settingsBlob) {
  const availablePrinters = _.get(settingsBlob, 'printing.printers', [])

  for (let printer of _.get(menuBlob, 'printers', [])) {
    cleanPrinter({ printer, availablePrinters })
  }
}

export function cleanPrinter ({ printer, settingsBlob, availablePrinters = null }) {
  if (!availablePrinters) {
    availablePrinters = _.get(settingsBlob, 'printing.printers', [])
  }

  const expectedType = printer.type === 'KITCHEN' ? 'RECEIPT' : 'LABEL'
  printer.physicalPrinters = _.get(printer, 'physicalPrinters', [])
    .filter(printerId => _.get(availablePrinters.find(it => it.id === printerId), 'type') === expectedType)
}
